import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let googleMapsConfigured = false;

const withGoogleMapsTimeout = async (promise, libraryName) => {
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = window.setTimeout(() => {
      reject(new Error(`No se pudo cargar Google Maps: ${libraryName}`));
    }, 10000);
  });

  try {
    return await Promise.race([promise, timeout]);
  } finally {
    window.clearTimeout(timeoutId);
  }
};

const configureGoogleMaps = () => {
  if (googleMapsConfigured) return;
  setOptions({
    key: GOOGLE_MAPS_API_KEY,
  });
  googleMapsConfigured = true;
};

export const loadPlacesLibrary = async () => {
  configureGoogleMaps();
  return await withGoogleMapsTimeout(importLibrary("places"), "places");
};

export const loadMapsLibrary = async () => {
  configureGoogleMaps();
  return await withGoogleMapsTimeout(importLibrary("maps"), "maps");
};

export const loadGeocodingLibrary = async () => {
  configureGoogleMaps();
  return await withGoogleMapsTimeout(importLibrary("geocoding"), "geocoding");
};

export const loadMarkerLibrary = async () => {
  configureGoogleMaps();
  return await withGoogleMapsTimeout(importLibrary("marker"), "marker");
};

export const loadRoutesLibrary = async () => {
  configureGoogleMaps();
  return await withGoogleMapsTimeout(importLibrary("routes"), "routes");
};
